<template>
    <aside :show.sync="show" placement="right" header="修改价格" :width="400">
    <form>
      <h4 class="text-center">【{{trip.catalog}}】{{trip.heading}}</h4>
      <template v-for="price in trip.price" track-by="$index">
        <div class="form-group">
          <div class="page-header"><span class="glyphicon glyphicon-paperclip"></span>价格{{$index + 1}}<button class="btn btn-xs btn-primary" type="button" @click="add()">添</button> <button type="button" @click="remove(price)" class="close" v-show="price.isDailyPrice != 1 ">&times;</button></div>
        </div>
        <div class="form-group">
          <label class="control-label">价格标题</label>
          <input type="text" class="form-control" v-model="price.title">
        </div>
        <div class="form-group">
          <label class="control-label">开始日期</label>
          <!-- <input type="datetime" class="form-control" data-field="datetime" v-model="price.startDate" :disabled="price.isDailyPrice == 1"> -->

          <input
            v-model="price.startDate"
            type="datetime-local"
            :disabled="price.isDailyPrice == 1"
            @change="price.startDate = price.startDate.replace('T', ' ')"
          ></input>
        </div>
        <div class="form-group">
          <label class="control-label">结束日期</label>
          <!-- <input type="datetime" class="form-control" data-field="datetime" v-model="price.endDate" :disabled="price.isDailyPrice == 1"> -->

          <input
            v-model="price.endDate"
            type="datetime-local"
            :disabled="price.isDailyPrice == 1"
            @change="price.endDate = price.endDate.replace('T', ' ')"
          ></input>
        </div>

        <div class="form-group">
          <label class="control-label">价格</label>
          <input type="text" class="form-control" v-model="price.price">
        </div>
        <!-- <div class="form-group">
          <label class="control-label">单位</label>
          <input type="text" class="form-control" v-model="price.unit">
        </div> -->
      </template>

      <div class="from-group text-center">
        <button class="btn btn-primary" type="button" @click="click(submit)($event)">提交</button>
      </div>
    </form>
  </aside>
</template>

<script>
  import { aside } from 'vue-strap'
  import config from '../../libs/config'
  import utils from '../../libs/utils'
  import { pick } from 'lodash'
  export default {
    components: {
      aside
    },
    props: {
      trip: {
        required: true,
        type: Object
      },
      show: {
        required: true,
        twoWay: true
      }
    },
    data () {
      return {
        tripStatus: config.tripStatus
      }
    },
    methods: {
      add () {
        this.trip.price.push({
          price: '',
          startDate: '',
          endDate: '',
          title: '',
          isDailyPrice: '0'
        })
      },
      remove (item) {
        if (item.isDailyPrice === '1') {
          return false
        }
        this.trip.price.$remove(item)
      },
      submit () {
        let prices = this.trip.price.map((item) => {
          return pick(item, [
            'price',
            'startDate',
            'endDate',
            'title',
            'isDailyPrice',
            'unit'
          ])
        })
        let data = {
          prices
        }
        return this.$http.put(`${config.apiWe}/product/trip/${this.trip.id}/price`, data)
          .then(() => {
            this.show = false
            this.$dispatch('callback')
          })
      },
      click: utils.click
    }
  }
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** ChangePrice.vue?c4800622
 **/